import { render } from "./Workdays.vue?vue&type=template&id=283ef7fa&scoped=true"
import script from "./Workdays.vue?vue&type=script&lang=js"
export * from "./Workdays.vue?vue&type=script&lang=js"

import "./Workdays.vue?vue&type=style&index=0&id=283ef7fa&lang=scss&scoped=true"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283ef7fa"]])

export default __exports__